/** @hidden */
export var _injectLTSScene = function (Scene) {
    Scene.prototype.setActiveCameraByID = function (id) {
        return this.setActiveCameraById(id);
    };
    Scene.prototype.getLastMaterialByID = function (id) {
        return this.getLastMaterialById(id);
    };
    Scene.prototype.getMaterialByID = function (id) {
        return this.getMaterialById(id);
    };
    Scene.prototype.getTextureByUniqueID = function (uniqueId) {
        return this.getTextureByUniqueId(uniqueId);
    };
    Scene.prototype.getCameraByID = function (id) {
        return this.getCameraById(id);
    };
    Scene.prototype.getCameraByUniqueID = function (uniqueId) {
        return this.getCameraByUniqueId(uniqueId);
    };
    Scene.prototype.getBoneByID = function (id) {
        return this.getBoneById(id);
    };
    Scene.prototype.getLightByID = function (id) {
        return this.getLightById(id);
    };
    Scene.prototype.getLightByUniqueID = function (uniqueId) {
        return this.getLightByUniqueId(uniqueId);
    };
    Scene.prototype.getParticleSystemByID = function (id) {
        return this.getParticleSystemById(id);
    };
    Scene.prototype.getGeometryByID = function (id) {
        return this.getGeometryById(id);
    };
    Scene.prototype.getMeshByID = function (id) {
        return this.getMeshById(id);
    };
    Scene.prototype.getMeshesByID = function (id) {
        return this.getMeshesById(id);
    };
    Scene.prototype.getTransformNodeByID = function (id) {
        return this.getTransformNodeById(id);
    };
    Scene.prototype.getTransformNodeByUniqueID = function (uniqueId) {
        return this.getTransformNodeByUniqueId(uniqueId);
    };
    Scene.prototype.getTransformNodesByID = function (id) {
        return this.getTransformNodesById(id);
    };
    Scene.prototype.getMeshByUniqueID = function (uniqueId) {
        return this.getMeshByUniqueId(uniqueId);
    };
    Scene.prototype.getLastMeshByID = function (id) {
        return this.getLastMeshById(id);
    };
    Scene.prototype.getLastEntryByID = function (id) {
        return this.getLastEntryById(id);
    };
    Scene.prototype.getNodeByID = function (id) {
        return this.getNodeById(id);
    };
    Scene.prototype.getLastSkeletonByID = function (id) {
        return this.getLastSkeletonById(id);
    };
};
